import React, { useEffect, useState, useCallback } from "react";

// Bootstrap imports
import {
  Row,
  Col,
  ButtonGroup,
} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import * as Icon from "react-bootstrap-icons";

// external libraries
import { ThreeCircles } from "react-loader-spinner";
import Select from "react-select";

// custom imports
import DropFileInput from "../../../reusable-components/DropFileComponent/DropFileComponent";
import { ReportGrid } from "../ReportGrid";
import { Switch } from "../LocalModeSwitch";
import { TemplateDownloadRenderer } from "../TemplateDownloadRenderer";

import { getFromLS, setToLS } from "../../../utils/storage";
import "../reports.css"
import OffCanvasNavbar from "../reportNavbar";
// highchart imports
import * as Highcharts from "highcharts/highstock";
import drilldown from "highcharts/modules/drilldown";
import HighchartsReact from "highcharts-react-official";
import * as HighchartsExporting from "highcharts/modules/exporting";
import { TemplateDescriptionPopover } from "../TemplatePopoverlay";
require("highcharts/modules/accessibility")(Highcharts);
// drilldown(Highcharts);
HighchartsExporting(Highcharts);
// Highcharts text formatter
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

// Report renderer
const WorkDistributionReport = () => {
  // set or declare default report variables
  const firm_id = 8
  // getFromLS("firmId");
  const vendor = "xcm"; // This report is specifically only for XCM
  const [isLoading, setIsLoading] = useState(true);
  const localChartTheme = getFromLS("chart-theme");

  // set default API params
  const [reportApiResponse, setReportApiResponse] = useState({
    data: { 0: { report: { data: [], report: [] } } },
  });

  // set local mode params
  const [localApiResponse, setLocalApiResponse] = useState({
    data: { 0: { report: { data: [], report: [] } } },
  });
  const [template_file_list, setTemplateFileList] = useState([]);
  const [templateDescription, setTemplateDescription] = useState("")
  const [localMode, setLocalMode] = useState(false);
  const [localLoaderToggle, setLocalLoaderToggle] = useState(true);

  // declare default grid params
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api;
    gridApi.closeToolPanel();
  }, []);

  // declare relevant report data variabled to be displayed, these will be set in the main processing function of the report
  const reportName = "Work Distribution Report";
  const [activeEmployees, setActiveEmployees] = useState("");
  const [hoursRemaining, setHoursRemaining] = useState("");
  const [reportDate, setReportDate] = useState("");
  const [xAxisCategories, setXaxisategories] = useState([])
  // clean toggle functionality
  const [cleanToggle, setCleanToggle] = useState(false);
  const [cleanOriginal, setCleanOriginal] = useState("Show cleaned");

  // fetch data from Work Distribution Report API
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firm_id, vendor }),
  };

  const getWorkDistributionReportData = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/work_distribution/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // API data state maintained
      .then((result) => setApiData(result, false))
      // Maintaining the templatye files sent from API response
      .then((result) => (setTemplateFiles(result)))
  };

  /**
 * In this function we set the API data and change state of chart and grid data. We use the localmode flag to maintain state and switch the chart to Report API data or Local mode API data.
 * @param {*} result: Work Distribution Report API response or Localmode API of this report.
 * @param {*} localMode: Flag.
 * @returns: API response (for further use).
 */
  const setApiData = (result, localMode = false) => {
    console.log("API DATA: ", result)
    if (localMode) {
      setLocalApiResponse(result);
    } else {
      setReportApiResponse(result);
    }
    // setting data to create required options for dropdown select
    gridParamsMapper(result)
    columnChartDataRenderer(result);
    return result;
  };

  /**
   * This function is used for formatting the default column names of the grid
   * @param {*} defaultName: Current name from API
   * @returns: Final column name
   */
  const GridColumnTitleRenderer = (defaultName) => {
    const splitWords = defaultName.split("_")
    for (let word in splitWords) {
      splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
    }
    return splitWords.join(" ")
  }

  /**
   * This function takes the API response data and maps it to the grid params
   * @param {*} result: API response
   */
  const gridParamsMapper = (result) => {
    console.log("GRID PARAM MAPPER RESULT:", result)
    if (result.data[0].report.data.length != 0) {
      const keys = Object.keys(result.data[0].report.report[0]) // You need to change this based on API response format in every report
      let jsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key)
        }
      });
      setColDefs(jsonColDefs)
    }
    setRowData(result.data[0].report.report);
  }

  /**
   * In this functionm, we pass the API response to extract template links to be displayed in local mode.
   * @param {*} result: API response.
   * @returns API response (for further use).
   */
  const setTemplateFiles = (result) => {
    const templates = result.data[0].report.templates
    setTemplateFileList(templates)
    const templateDescriptionHolder = []
    for(let template in templates){
      Object.assign(templateDescriptionHolder, {[templates[template].name + templates[template].extension]: templates[template].description})
    }
    setTemplateDescription(templateDescriptionHolder)
    return result
  }

  /**
   * This function enables the local mode and maintains the state of loaders and messages to be displayed.
   */
  const LocalModeEnabler = () => {
    setLocalLoaderToggle(true);
    if (localMode) {
      console.log("LOCAL MODE API RESPONSE: ", localApiResponse)
      setLoaderText(true);
      setApiData(reportApiResponse, false);
      setLocalLoaderToggle(false);
    }
    setLocalMode(!localMode);
  };

  /**
   * This function accepts the uploaded template excel files and adds them to the payload for making Local Mode API call
   * @param {*} files 
   */
  const onFileChange = (files) => {
    const formData = new FormData();
    formData.append("file1", files[0]);
    LocalModeApi(formData)
  };

  /**
   * This function takes the payload of uploaded excel files and makes the Local Mode API call
   * @param {*} formData: Payload.
   */
  const LocalModeApi = (formData) => {
    // updating payload for Local Mode API
    formData.append("report_name", "work_distribution");
    // This times out the loader till charts are generated
    if (formData) {
      setLoaderText(!loaderText);
      setTimeout(() => {
        setLocalLoaderToggle(false);
      }, 3000);
    }
    // call api and get data
    const requestOptions = {
      method: "POST",
      body: formData,
    };
    console.log("REQUEST OPTIONS: ", requestOptions);
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/local/get_reports/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // Local Mode API data state maintained
      .then((result) => {
        console.log("LOCAL MODE API: ", result)
        if (result.success === true) {
          setLoaderText(!loaderText);
          setApiData(result, true)
          setTimeout(() => {
            setLocalLoaderToggle(false);
          }, 3000);
        } else {
          console.log("FAILED TO LOAD A LOCAL FILE!")
          setLocalLoaderToggle(true);
        }
      }
      ).catch(error => {
        console.error('ERROR IN LOCAL MODE API:', error);
      })
  }

  // declaring and setting default data params for chart
  const [columnChartData, setColumnChartData] = useState({
    name: "Work distribution",
    colorByPoint: true,
    data: [],
  });

  /**
   * This is the core function for rendering chart in Work Distribution Report.
   * @param {*} result : API data
   * @param {*} clear : filter to be applied on chart data
   */
  const columnChartDataRenderer = (result, clear) => {

    let reportData = result.data[0].report.data;

    console.log("REPOPRT DATA WD: ", reportData)
    // set up the report chip data from API response
    setActiveEmployees(result.data[0].report.current_active_employees);
    setHoursRemaining(result.data[0].report.hours_remain_in_busy_season);
    setReportDate(result.data[0].report.most_recent_report_date);

    const xAxisCategoryField = "TypeCode"
    const categories = [];
    const data = [];
    if (clear) {
      for (let record in reportData) {
        if (reportData[record]["distribution"] != 0) {
          categories.push(reportData[record][xAxisCategoryField])
          data.push(reportData[record]["distribution"])
        }
      }
    }
    else {
      for (let record in reportData) {
        categories.push(reportData[record][xAxisCategoryField])
        data.push(reportData[record]["distribution"])
      }
    }

    setXaxisategories(categories)
    const columnChartDataHolder = {
      name: "Task distribution",
      colorByPoint: true,
      data: data,
    };
    console.log("COLUMN DATA: ", columnChartDataHolder)
    console.log("X AXIS CATEGORIES: ", xAxisCategories)
    setColumnChartData(columnChartDataHolder);
  };

  const handleClean = (clear) => {
    setCleanToggle(!cleanToggle);
    let reportData = reportApiResponse.data[0].report.data;
    const xAxisCategoryField = "TypeCode"
    const categories = [];
    const data = [];
    if (clear) {
      setCleanOriginal("Show original");
      for (let record in reportData) {
        if (reportData[record]["distribution"] != 0) {
          categories.push(reportData[record][xAxisCategoryField])
          data.push(reportData[record]["distribution"])
        }
      }
    }
    else {
      setCleanOriginal("Show cleaned");
      for (let record in reportData) {
        categories.push(reportData[record][xAxisCategoryField])
        data.push(reportData[record]["distribution"])
      }
    }

    setXaxisategories(categories)
    const columnChartDataHolder = {
      name: "Task distribution",
      colorByPoint: true,
      data: data,
    };
    console.log("COLUMN DATA: ", columnChartDataHolder)
    console.log("X AXIS CATEGORIES: ", xAxisCategories)
    setColumnChartData(columnChartDataHolder);
  }

  const [loaderText, setLoaderText] = useState(false);

  // interactive primary chart
  const primaryOptions = {
    chart: {
      type: "column",
      height: 600,
    },
    title: {
      align: "center",
      text: "Work distribution",
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      categories: xAxisCategories,
      min: 0,
      max: cleanToggle ? 6 : 12,
      offset: 25,
      tickWidth: 2,
      tickLength: 10,
    },
    scrollbar: {
      enabled: true,
    },

    yAxis: {
      title: {
        text: "Number of tasks",
      },
    },

    plotOptions: {
      column: {
        groupPadding: 0.1,
        pointPadding: 0.1,
        stacking: "normal",
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span> <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },
    series: [columnChartData],
  };

  // grid export functionality
  const onBtExcelExport = useCallback(() => {
    gridApi.exportDataAsExcel();
  }, []);

  const onBtCSVExport = useCallback(() => {
    gridApi.exportDataAsCsv();
  }, []);

  // loader awaiting api response and page renderx
  const loader = reportApiResponse && columnChartData.data != [];

  // we are adding this buffer timeout for the charts to render before appearing
  useEffect(() => {
    if (loader) {
      setIsLoading(false);
      setTimeout(() => {
        setLocalLoaderToggle(false);
        setLoaderText(true);
      }, 2000);
    }
  }, [loader]);

  // Loading data for the first time.
  if (isLoading) {
    getWorkDistributionReportData();
  }

  return (
    <>
      <div className="row-wrapper">
        <div className="row-container">
          {localMode ? (
            <>
              <h3 className="intelligence-report-name">{reportName}</h3>
              <Row className="local-import-row">
                <Col md={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <p style={{ color: "#000", fontWeight: "900", marginBottom: 10, marginRight: 20 }}> Download templates
                    <TemplateDescriptionPopover
                      description={templateDescription}
                    />
                  </p>
                  <Row className="no-gutter">
                    {
                      template_file_list && template_file_list.map((object, index) => (
                        <TemplateDownloadRenderer info={object} key={index} />
                      )
                      )
                    }
                  </Row>
                </Col>
                {
                  template_file_list && template_file_list.map((index) =>
                    <Col md={10 / template_file_list.length} key={index}>
                      <DropFileInput onFileChange={(files) => onFileChange(files)} />
                    </Col>
                  )
                }
              </Row>
            </>
          ) : (
            <>
              <h3 className="intelligence-report-name">Work Distribution Report</h3>
              <Row className="report-card-row">
                <div className="report-card">
                  <div className="chip-header">Active employees</div>
                  <div className="chip-body">{activeEmployees}</div>
                </div>
                <div className="report-card">
                  <div className="chip-header">
                    Hours remaining in busy season
                  </div>
                  <div className="chip-body">{hoursRemaining}</div>
                </div>
                <div className="report-card">
                  <div className="chip-header">Most recent report date</div>
                  <div className="chip-body">{reportDate}</div>
                </div>
              </Row>
            </>
          )}
        </div>
      </div>

      <div className="row-wrapper">
        <div className="row-container">
          <Tabs
            defaultActiveKey="chart"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="chart" title="Chart" className="tabs">
              <OffCanvasNavbar
                localtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      {localMode ? (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Go back online
                        </p>
                      ) : (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Switch to local mode
                        </p>
                      )}
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={localMode}
                        onClick={() => LocalModeEnabler()}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
                secondtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      <p style={{ color: "#000", fontWeight: 500 }}>{cleanOriginal}</p>
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={cleanToggle}
                        onClick={() => handleClean(!cleanToggle)}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
              />

              <Row>
                <Col md="12" className="chart-holder">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <div className="chart-container">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={primaryOptions}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="grid" title="Grid" className="tabs">
              <DropdownButton
                as={ButtonGroup}
                className="reset-button download-excel"
                title=" Export"
                id="bg-nested-dropdown"
                drop="start"
              >
                <Dropdown.Item onClick={onBtExcelExport}>
                  {" "}
                  <Icon.FileExcel /> Excel Export
                </Dropdown.Item>
                <Dropdown.Item onClick={onBtCSVExport}>
                  {" "}
                  <Icon.FiletypeCsv /> CSV Export
                </Dropdown.Item>
              </DropdownButton>
              <Row>
                <Col md="12" className="grid-row staffing">
                  <ReportGrid
                    rowData={rowData}
                    colDefs={colDefs}
                    onGridReady={onGridReady}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default WorkDistributionReport;
